import { keys, reduce } from "lodash";
import { OwnerType, SolicitorRequestType, StageDSolicitorApplicationForm } from "../../../models/classes/stage-d/Review-Application.class";
import { LegalRepresentation, PrivateSolicitor } from "../../../models/classes/ApplicationStep3.class";
import { InputError } from "../../../hooks/use-form";
import { SharedValidators } from "../shared/validators";

export const validateStageDSolicitor = (values: StageDSolicitorApplicationForm, additionalFields: any) => {
  return values.solicitors?.map((solicitor_value) => {
    const fields = keys(solicitor_value);
    const errors: any = reduce(
      fields,
      (result, field: string) => {
        if (field === "proposed" && additionalFields.ownerType === "PROPOSED_OWNER") {
          let validatedResult = validateStageDLegalRepresentation(solicitor_value, field, additionalFields.solicitorType);
          return { ...result, [field]: validatedResult };
        } else if (field === "current" && additionalFields.ownerType === "CURRENT_OWNER") {
          let validatedResult = validateStageDLegalRepresentation(solicitor_value, field, additionalFields.solicitorType);
          return { ...result, [field]: validatedResult };
        } else if (field === "outgoing" && additionalFields.ownerType === "OUTGOING_OWNER") {
          let validatedResult = validateStageDLegalRepresentation(solicitor_value, field, additionalFields.solicitorType);
          return { ...result, [field]: validatedResult };
        } else {
          return { ...result, [field]: { isValid: true } };
        }
      },
      {}
    );
    console.log("errors", errors)
    return errors;
  });
};

export const validateStageDLegalRepresentation = (values: any, name: string, solicitorType: SolicitorRequestType, allow_conveyancing: boolean = true) => {
  const legal_representation: LegalRepresentation = values[name];

  const errors: any = reduce(keys(legal_representation), (result, field: any, _index: number) => {
    const passAllValidations = {
      email_of_solicitor: {isValid: true},
      is_confirm: {isValid: true},
      name_of_firm: {isValid: true},
      uen: {isValid: true},
    }

    if (field === "private_solicitor") {
      if (solicitorType === "MORTGAGE" || solicitorType === "BOTH") {
        const validation = validateStageDPrivateSolicitor(values[name], field);
        return { ...result, [field.toString()]: validation }
      } else if (solicitorType === "CONVEYANCING") {
        return { ...result, [field.toString()]: passAllValidations }
      }
    }

    if (field === "conveyancing_private_solicitor") {
      if (solicitorType === "CONVEYANCING") {
        const validation = validateStageDPrivateSolicitor(values[name], field);
        return { ...result, [field.toString()]: validation }
      } else if (solicitorType === "BOTH" && allow_conveyancing && values[name].private_solicitor.represented_same_solicitor === false) {
        const validation = validateStageDPrivateSolicitor(values[name], field);
        return { ...result, [field.toString()]: validation }
      } else if (solicitorType === "MORTGAGE") {
        return { ...result, [field.toString()]: passAllValidations }
      }
    }

    return { ...result}
  }, {});
  // console.log("errors", errors)
  return errors;


}

export const validateStageDPrivateSolicitor = (values: any, name: string) => {
  const hdb_solicitor: PrivateSolicitor = values[name];
  const errors: any = reduce(keys(hdb_solicitor), (result, field: any, _index: number) => {
    let validation = validateStageDPrivateSolicitorFields(hdb_solicitor, field);
    return { ...result, [field.toString()]: validation };
  }, {});
  return errors;
}

export const validateStageDPrivateSolicitorFields = (values: any, name: string) => {
  const value = values[name];
  let error: InputError | undefined = { isValid: true };

  switch (name) {
    case "uen":
      error = SharedValidators.Basic(value);
      break;
    case "name_of_firm":
      error = SharedValidators.BasicEmpty(value);
      if (value === "") {
        error = { isValid: false, message: "This is a required field." };
      }
      break;
    case "email_of_solicitor":
      error = SharedValidators.Email(value);
      break;
  }

  return error;
}
